/** Path to a kiosk product's detail modal, optionally carrying a discount. */
export function getProductDetailPath(productId: string, discountId?: string) {
  return discountId
    ? `/kiosk/products/${productId}?discount=${discountId}`
    : `/kiosk/products/${productId}`;
}
